import mixin from "@/mixins/mixin.js";
import dynvibebasechart from "@/components/vueCharts/DynvibeBaseChart.vue";
import dynvibegraphdetails from "@/components/vueCharts/GraphDetails.vue";

const graphMixin = {
	mixins: [mixin],
	props: {
		axios: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: null,
		},
		clickable: {
			default: true,
		},
		anydate: {
			default: false,
		},
		compare: {
			default: false,
		},
		firstgraph: {
			default: false,
		},
		type: {
			type: String,
			default: "chart",
		},
		incomingModal: {
			default: false,
		},
		levelmixin: {
			type: String,
			default: "",
		},
		mainkeywordmixin: {
			type: String,
			default: "",
		},
		datemixin: {
			type: Object,
			default: {
				gte: "",
				lte: "",
			},
		},
		countrymixin: {
			type: String,
			default: "",
		},
		filters: {
			type: Object,
			default: {},
		},
	},
	data() {
		return {
			showGraphDetails: {},
			axiosComputed: this.axios, // init axiosComputed like axios. Not in mounted it's "too late"
			noData: false,
			loaded: false,
		};
	},
	components: {
		dynvibebasechart: dynvibebasechart,
		dynvibegraphdetails: dynvibegraphdetails,
	},
	methods: {
		chartCreated() {
			this.setChartOptions();
			this.loaded = true;
		},
		loadComponent(parameters = []) {
			if (this.incomingModal) {
				let params = {
					parameters: {
						...this.trendfilters,
						...this.modalkeywords,
						...this.semanticfilters,
					},
					level: this.levelmixin,
					mainkeyword: this.mainkeywordmixin,
					id: this.axiosComputed,
				};
				if (this.axiosComputed == "storiesTopicLine" || this.axiosComputed == "categoriesVolume") {
					this.getData("graph", params);
				} else {
					this.getData("graphTrends", params);
				}
			} else if (this.explorePage) {
				let params = {
					parameters: {
						//...this.$parent.$parent.filters,
						...this.$parent.filters,
						...parameters,
					},
					id: this.axiosComputed,
				};

				if (this.mainkeywordmixin !== "") {
					params.mainkeyword = this.mainkeywordmixin;
				}
				if (this.levelmixin !== "") {
					params.level = this.levelmixin;
				}
				if (this.datemixin.gte != "") {
					params.parameters.date = this.datemixin;
				}
				if (this.datemixin.gte != "") {
					params.parameters.date = this.datemixin;
				}
				if (this.countrymixin != "") {
					params.parameters.country = [this.countrymixin];
				}

				if (
					this.axiosComputed === "mostAssociatedBrands" ||
					this.axiosComputed === "mostAssociatedTopics" ||
					this.axiosComputed === "mostAssociatedTrends"
				) {
					this.getData("graphTrends", params);
				} else {
					this.getData("graph", params);
				}
			} else {
				let p = parameters;

				let baseChart = this.$refs.basechart;
				if (baseChart) {
					baseChart.setLoading(true);
				}

				if (this.axiosComputed) {
					let params = {
						parameters: p,
						data: {
							anydate: this.anydate,
						},
						id: this.axiosComputed,
					};

					if (!this.compare) {
						this.getData("graph", params);
					} else {
						this.getData("graphCompare", params);
					}
				}
			}
		},
		treatResponse(response) {
			setTimeout(() => {
				let baseChart = this.$refs.basechart;
				if (baseChart) {
					baseChart.setLoading(false);
					if (!response.data.resultscount) {
						this.noData = true;
						baseChart.setNoData(true);
					} else {
						this.noData = false;
						baseChart.setNoData(false);
						this.loadChartData(response.data.results);
					}
				}
			}, 500);
		},
		setChartOptions() {
			// To be surcharged by children
		},
		loadChartData(results) {
			console.log(results);
			// To be surcharged by children
		},
		clickGraph(event, backPreviousGraph = false, data = "", point = "") {
			if (this.clickable && this.incomingModal) {
				this.$parent.$parent.getDataGraph(event, this.axiosComputed);
			} else if (this.clickable && this.explorePage) {
				this.$parent.$parent.keywordClicked({ keyword: event.point.category, level: this.levelmixin });
			} else if (this.clickable) {
				this.showGraphDetails[this.axiosComputed] = true;
				this.$refs["graphDetails" + this.axiosComputed].getDataGraph(event, true);
			}
			console.log(backPreviousGraph); // avoiding warinings
			console.log(data); // avoiding warinings
			console.log(point); // avoiding warinings
		},
	},
	watch: {
		filters: {
			deep: true,
			handler() {
				this.loadComponent(this.filters);
			},
		},
		"$this.$store.state.datecompare": function () {
			if (this.compare) {
				this.loadComponent(this.$store.getters.parameters);
			}
		},
		"$this.$store.state.parameters": function () {
			if (this.firstgraph) {
				if (this.$store.getters.parameters.mastertag) {
					this.axiosComputed = "mastertagCount";
				} else if (this.$store.getters.parameters.subcategory) {
					this.axiosComputed = "mastertagFromsubcategory";
				} else if (this.$store.getters.parameters.category) {
					this.axiosComputed = "subcategoryFromcategory";
				} else {
					if (this.$store.getters.pageName === "topics") {
						this.axiosComputed = "categoryByProfile";
					} else {
						this.axiosComputed = "subcategoryByProfile";
					}
				}
			}
			this.loadComponent(this.$store.getters.parameters);
		},
	},
};

export default graphMixin;
